<div class="w-full">
    <ng-content></ng-content>
</div>


